/**
 * Important
This file is used only for the vue3 application

Changes made here will not be reflected in the new Vue2 application.
You need to make changes in the vue2 file also
Vue3 file: Velocity.PrimaryOffersites.Web\wwwroot\vue3\src\Services\Payments\PaymentsService.js

Any clarifications contact Leela Directly
 */
import axios from 'axios';
import store from '../../../store/store';
import {
  CASH,
  FINANCE,
  LEASE,
  TOYOTA_INCENTIVE_DDOA_SOURCE,
  TOYOTA_INCENTIVE_SOURCE,
  VEHICLE_TYPE_CPO,
  VEHICLE_TYPE_NEW,
  VEHICLE_TYPE_USED,
} from '../../constants/constants';
import {
  EXPRESS_PAYMENTS_SET_YOUR_PRICE_DATA,
  PAYMENT_CONFIGURATION_DOWN_PAYMENT,
  PAYMENT_CONFIGURATION_MILEAGE,
  PAYMENT_CONFIGURATION_TERM,
  PAYMENT_CONFIGURATION_TRADE_VALUE,
  SUMMARY_INCENTIVES,
  SUMMARY_PAYMENTDATA,
  SUMMARY_SELECTED_VALUES,
  SUMMARY_SERVICEPROTECTIONPLAN,
} from '../../constants/expresspaymentconstants';
import { Payments } from './Payments';
import {
  EXPRESS_GET_SELECTED_INCENTIVES,
  EXPRESS_SET_CASH_INCENTIVES,
  EXPRESS_SET_DISCOUNT_INCENTIVES_LOADED,
  EXPRESS_SET_FINANCE_INCENTIVES,
  EXPRESS_SET_LEASE_INCENTIVES,
  EXPRESS_SET_PAYMENT_CONFIGURATION,
  EXPRESS_SET_PAYMENTS_NOT_FOUND_ERROR,
  EXPRESS_SET_REGIONS,
  EXPRESS_SET_REGIONS_CHANGE,
  EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT,
  EXPRESS_SET_SUMMARY_DATA,
  SET_SELECTEDPAYMENTOPTION,
} from './../../../store/types';
import { ExpressPayments } from './ExpressPayments';
import { isFordDealer } from '../FordDirect/FordCookieService';
import { transactActiveSectionLoaded } from '../TransactServices/TransactBootstrap';
import { TRANSACT_INCENTIVES_SECTION } from '../../../store/StoreConstants/TransactConstants';
import { ExpressPaymentsBaseService } from '../../Common/Payments/ExpressPaymentsBaseService';

export function isCallForPriceAvailable(paymentSettings, priceValue) {
  if (
    paymentSettings.vehicleType &&
    ((paymentSettings.vehicleType.toLowerCase() === 'new' && paymentSettings.showCallForPriceVDP) ||
      (paymentSettings.vehicleType.toLowerCase() === 'used' &&
        paymentSettings.showCallForPriceVDPUsed))
  ) {
    return true;
  }

  if (!paymentSettings.yourPrice || paymentSettings.yourPrice <= 0) {
    return true;
  }

  if (paymentSettings.vehicleType.toLowerCase() === 'new') {
    if (
      (!paymentSettings.msrp || paymentSettings.msrp <= 0) &&
      (!paymentSettings.yourPrice || paymentSettings.yourPrice <= 0)
    )
      return true;
  }

  return !priceValue && Payments.isVirtualVdpPage();
}

export function isCallForPriceEnabled(paymentSettings, priceValue) {
  let showCRFForDealerGroupFamily = window.showCRFForDealerGroupFamily;
  let isDealerGroup = window.isDealerGroup;
  let isInventoryMatch = window.isInventoryMatch;
  return (
    (showCRFForDealerGroupFamily && isDealerGroup) ||
    isInventoryMatch ||
    ((!isDealerGroup || priceValue <= 0) && isCallForPriceAvailable(paymentSettings, priceValue))
  );
}

export function calculateTaxWithoutPayments(paymentsResponse, cashSummaryData) {
  let cashTaxData = paymentsResponse?.Cash;
  let paymentsData = cashSummaryData.paymentsData ? { ...cashSummaryData.paymentsData } : {};
  paymentsData.AtcFeeDetails = { ...cashTaxData };
  let summaryData = {
    ...cashSummaryData,
    paymentsData,
  };

  store.commit(EXPRESS_SET_SUMMARY_DATA, {
    type: SUMMARY_PAYMENTDATA,
    selectedPaymentOption: 'cash',
    value: summaryData,
  });
}

export function getPriceValueForCash(paymentSettings, financeData) {
  let priceValue = '';
  let priceLabel = '';

  let priceValues = '';
  try {
    priceValues = Payments.getYourPriceData(
      paymentSettings,
      CASH.toLowerCase(),
      financeData,
      false,
      true,
      true
    );
  } catch (e) {
    console.log(e);
  }
  if (priceValues.key) {
    priceLabel = priceValues.key;
  }
  priceValue = Payments.conventStringToNumber(priceValues.value);
  if (isCallForPriceAvailable(paymentSettings, priceValue)) {
    priceValue = 'Call For Price';
    priceLabel = '';
  } else {
    priceValue = '$' + priceValue;
  }
  store.commit(EXPRESS_PAYMENTS_SET_YOUR_PRICE_DATA, {
    label: priceLabel,
    value: priceValue,
  });

  return { priceLabel, priceValue };
}

export function calculateSummaryDataForCash() {
  const paymentSettings = store.state.paymentsettings.settings;
  const financeData =
    store.state.expressPaymentSettings.summaryData['cash'][SUMMARY_PAYMENTDATA].paymentsData;

  const summaryData = store.state.expressPaymentSettings.summaryData['cash'];

  const tradeValue = store.state.expressPaymentSettings.mainTradeValue;

  const accessoriesList = store.state.expressPaymentSettings.selectedAccessories;

  const { priceLabel, priceValue } = getPriceValueForCash(paymentSettings, financeData);

  setSummaryDataForCash(
    paymentSettings,
    priceLabel,
    priceValue,
    summaryData?.paymentData,
    '',
    tradeValue,
    { accessoriesList: accessoriesList?.length ? accessoriesList : [] }
  );
}

export function getCashIncentivesAmount(summaryDataOnlyPayments) {
  let incentives = 0;

  const incentiveCash = summaryDataOnlyPayments?.IncentiveCash || 0;

  if (incentiveCash) {
    incentives = Payments.conventStringToNumber(incentiveCash);
  }

  // Assuming `incentivesAmount` is a number or can be safely coerced to a number

  return incentives;
}

export function getUserSelectedIncentves() {
  const selectedIncentives = store.getters[EXPRESS_GET_SELECTED_INCENTIVES];

  let selectedIncentivesAmount = 0;
  if (selectedIncentives && selectedIncentives !== '') {
    selectedIncentivesAmount = selectedIncentives?.reduce((total, item) => total + item.Cash, 0);
  }
  return selectedIncentivesAmount;
}

export function getServiceProtectionPlansTotalPrice(serviceProtectionPlans) {
  return serviceProtectionPlans.reduce((total, item) => {
    total += Payments.conventStringToNumber(item?.cashPrice);
    return total;
  }, 0);
}

export function setSummaryDataForCash(
  paymentSettings,
  priceLabel,
  priceValue,
  summaryData,
  incentivesAmount,
  tradeValue,
  params = { accessoriesList: [] }
) {
  let finalPrice = Payments.conventStringToNumber(priceValue);
  let appliedTrade = Payments.conventStringToNumber(tradeValue);
  tradeValue = Payments.conventStringToNumber(tradeValue);
  let serviceProtectionPrice = 0;
  let accessoriesPrice = 0;
  const serviceProtectionPlans =
    store.state.expressPaymentSettings.summaryData['cash'][SUMMARY_SERVICEPROTECTIONPLAN];

  if (serviceProtectionPlans?.length) {
    serviceProtectionPrice = getServiceProtectionPlansTotalPrice(serviceProtectionPlans);
  }
  if (params?.accessoriesList?.length) {
    accessoriesPrice = getAccessoriesPrice(params?.accessoriesList);
  }

  let cashBack = 0;

  if (priceValue === 'Call For Price') {
    finalPrice = priceValue;
  } else {
    if (!summaryData?.paymentsData?.PurchasePrice) {
      if (summaryData?.paymentsData?.AtcFeeDetails?.FeeTotal) {
        finalPrice =
          finalPrice +
          Payments.conventStringToNumber(summaryData?.paymentsData?.AtcFeeDetails?.FeeTotal);
      }
    }

    if (tradeValue) {
      if (finalPrice > tradeValue) {
        finalPrice = finalPrice - Payments.conventStringToNumber(tradeValue);
      } else {
        cashBack = tradeValue - finalPrice;
        appliedTrade = finalPrice;
        finalPrice = 0;
      }
    }

    if (serviceProtectionPrice) {
      finalPrice += serviceProtectionPrice;
    }
    if (accessoriesPrice) {
      finalPrice += accessoriesPrice;
    }
  }

  console.log(priceValue);
  console.log(finalPrice);
  console.log(summaryData);

  const oldSummaryData = typeof summaryData === 'object' && summaryData ? { ...summaryData } : {};

  let summary = {
    ...oldSummaryData,
    msrp: paymentSettings.msrp,
    yourPrice: priceValue,
    yourPriceLabel: priceLabel,
    incentives: summaryData.incentives ? summaryData.incentives : 0,
    appliedTrade,
    accessoriesPrice,
    taxes: summaryData?.paymentsData?.AtcFeeDetails?.FeeTotal
      ? summaryData?.paymentsData?.AtcFeeDetails?.FeeTotal
      : 0,
    finalPrice,
    cashBack,
  };

  store.commit('summaryDataForCash', { type: 'paymentData', option: 'cash', value: summary });
}

export function setCashTaxSummaryData(summaryData, paymentsData) {
  let appliedTrade = 0;
  let finalPrice = Payments.conventStringToNumber(summaryData.yourPrice);
  if (summaryData.incentives) {
    finalPrice = finalPrice - Payments.conventStringToNumber(summaryData.incentives);
  }

  if (paymentsData?.AtcFeeDetails?.FeeTotal) {
    finalPrice = finalPrice + Payments.conventStringToNumber(paymentsData.AtcFeeDetails.FeeTotal);
  }
  const expressPaymentsFeesData = store.state?.paymentsettings?.expressPaymentsFeesData;
  if (expressPaymentsFeesData?.length) {
    let transactSpecialFee = getSpecialTransactFeeData();
    if (transactSpecialFee) {
      finalPrice = finalPrice + transactSpecialFee;
    }
  }

  let cashBack = 0;
  if (summaryData.appliedTrade) {
    appliedTrade =
      Payments.conventStringToNumber(summaryData.appliedTrade) +
      Payments.conventStringToNumber(summaryData.cashBack);
    if (appliedTrade > finalPrice) {
      cashBack = appliedTrade - finalPrice;
      appliedTrade = finalPrice;
      finalPrice = 0;
    } else {
      finalPrice = finalPrice - appliedTrade;
    }
  }

  let summary = {
    ...summaryData,
    taxes: paymentsData?.AtcFeeDetails?.FeeTotal,
    finalPrice,
    cashBack,
    appliedTrade,
    paymentsData: paymentsData,
  };

  store.commit('summaryDataForCash', { type: 'paymentData', option: 'cash', value: summary });
}

export function setSummaryDataForCashIncentives(incentivesAmount, summaryData, tradeValue) {
  let finalPrice = Payments.conventStringToNumber(summaryData.yourPrice);

  if (incentivesAmount) {
    finalPrice = finalPrice - Payments.conventStringToNumber(incentivesAmount);
  }

  if (summaryData.taxes) {
    finalPrice = finalPrice + Payments.conventStringToNumber(summaryData.taxes);
  }
  const expressPaymentsFeesData = store.state?.paymentsettings?.expressPaymentsFeesData;
  if (expressPaymentsFeesData?.length) {
    let transactSpecialFee = getSpecialTransactFeeData();
    if (transactSpecialFee) {
      finalPrice = finalPrice + transactSpecialFee;
    }
  }

  let appliedTrade = 0;
  let cashBack = 0;
  if (tradeValue) {
    appliedTrade = tradeValue;
    if (finalPrice > tradeValue) {
      finalPrice = finalPrice - Payments.conventStringToNumber(tradeValue);
    } else {
      cashBack = tradeValue - finalPrice;
      appliedTrade = finalPrice;
      finalPrice = 0;
    }
  }

  let summary = {
    ...summaryData,
    incentives: incentivesAmount,
    finalPrice,
    appliedTrade,
    cashBack,
  };

  console.log(summary);
  store.commit('summaryDataForCash', { type: 'paymentData', option: 'cash', value: summary });
}

export function removeAppliedTradeFromFinalPrice(summaryData) {
  let summary = {
    ...summaryData,
    appliedTrade: 0,
    cashBack: 0,
  };
  store.commit('summaryDataForCash', { type: 'paymentData', option: 'cash', value: summary });
  calculateSummaryDataForCash();
}

export function removeTaxesFromSummaryData(summaryData, tradeValue) {
  let finalPrice = Payments.conventStringToNumber(summaryData.yourPrice);
  let appliedTrade = tradeValue;
  let cashBack = 0;
  if (summaryData.incentives) {
    finalPrice = finalPrice - Payments.conventStringToNumber(summaryData.incentives);
  }
  const expressPaymentsFeesData = store.state?.paymentsettings?.expressPaymentsFeesData;
  if (expressPaymentsFeesData?.length) {
    let transactSpecialFee = getSpecialTransactFeeData();
    if (transactSpecialFee) {
      finalPrice = finalPrice + transactSpecialFee;
    }
  }

  if (tradeValue) {
    if (finalPrice > tradeValue) {
      finalPrice = finalPrice - Payments.conventStringToNumber(tradeValue);
    } else {
      cashBack = tradeValue - finalPrice;
      appliedTrade = finalPrice;
      finalPrice = 0;
    }
  }

  let summary = {
    ...summaryData,
    appliedTrade,
    cashBack,
    taxes: 0,
    finalPrice,
  };
  store.commit('summaryDataForCash', { type: 'paymentData', option: 'cash', value: summary });
}

export function isPaymentsOverlayEnabled(paymentsOverlayData, selectedPaymentOption) {
  if (paymentsOverlayData.enableOverleyOnTransact) {
    return false;
  }
  if (!paymentsOverlayData?.enableOverleyOnVDP) {
    return false;
  }

  if (window.isauthenticated === 'True') {
    if (!paymentsOverlayData.showForLoggedInUsers) {
      return false;
    }
  }

  if (!paymentsOverlayData.isLeasePayment) {
    return false;
  }
  if (!paymentsOverlayData.isFinancePayment && selectedPaymentOption === 'finance') {
    return false;
  }
  return !(!paymentsOverlayData.isCashPayment && selectedPaymentOption === 'cash');
}

export function formatSavingsData(totalSavingsData) {
  const paymentsSavingsData = [];

  let arrayIndex = 0;
  let i = 0;

  for (let item in totalSavingsData) {
    if (i > 3) {
      arrayIndex++;
      i = 0;
    }

    if (i === 0) {
      paymentsSavingsData[arrayIndex] = [];
    }

    i++;

    if ((item === 'X Plan' || item === 'A/Z Plan') && window.showAZXPlanDescription) {
      if(item === 'A/Z Plan') {
          paymentsSavingsData[arrayIndex].push({
            key: item,
            value: totalSavingsData[item],
            icon: 'primaryicon-info',
            disclaimer:
              '<div><p><strong>A Plan:</strong> Current, active, full-time hourly employees and regular salaried employees.</p> <p><strong>Z Plan:</strong> Ford retirees and immediate family members of current or retired Ford employees.</p></div> '
          });
      } else if(item === 'X Plan') {
        paymentsSavingsData[arrayIndex].push({
          key: item,
          value: totalSavingsData[item],
          icon: 'primaryicon-info',
          disclaimer:' <div><p><strong>X Plan:</strong> Friends, neighbors, and partners of Ford employees.</p></div>'
        });
      }
    } else {
      paymentsSavingsData[arrayIndex].push({
        key: item,
        value: totalSavingsData[item],
      });
    }
  }

  return paymentsSavingsData;
}

export function adminDefaultPaymentSelectionSettings(leaseData, financeData) {
  if (!(new URLSearchParams(window.location.search).has('type'))) {
    const adminDefaultValueNew = window.defaultvdppaymenttypenew
      ? window.defaultvdppaymenttypenew
      : '';
    const adminDefaultValueUsed = window.defaultvdppaymenttypeused
      ? window.defaultvdppaymenttypeused
      : '';
    const adminDefaultValueCpo = window.defaultvdppaymenttypecpo
      ? window.defaultvdppaymenttypecpo
      : '';

    if (
      adminDefaultValueNew &&
      window.vehicleType.toLowerCase() === VEHICLE_TYPE_NEW.toLowerCase()
    ) {
      if (adminDefaultValueNew.toLowerCase() === FINANCE.toLowerCase() && financeData) {
        store.commit(SET_SELECTEDPAYMENTOPTION, FINANCE.toLowerCase());
      } else if (adminDefaultValueNew.toLowerCase() === LEASE.toLowerCase() && leaseData) {
        store.commit(SET_SELECTEDPAYMENTOPTION, LEASE.toLowerCase());
      } else if (adminDefaultValueNew.toLowerCase() === CASH.toLowerCase()) {
        store.commit(SET_SELECTEDPAYMENTOPTION, CASH.toLowerCase());
      } else {
        // No action needed for other cases.
      }
    }

    if (
      adminDefaultValueUsed &&
      window.vehicleType.toLowerCase() === VEHICLE_TYPE_USED.toLowerCase()
    ) {
      if (adminDefaultValueUsed.toLowerCase() === FINANCE.toLowerCase() && financeData) {
        store.commit(SET_SELECTEDPAYMENTOPTION, FINANCE.toLowerCase());
      } else if (adminDefaultValueUsed.toLowerCase() === CASH.toLowerCase()) {
        store.commit(SET_SELECTEDPAYMENTOPTION, CASH.toLowerCase());
      } else {
        // No action needed for other cases.
      }
    }

    if (
      adminDefaultValueCpo &&
      window.vehicleType.toLowerCase() === VEHICLE_TYPE_CPO.toLowerCase()
    ) {
      if (adminDefaultValueCpo.toLowerCase() === FINANCE.toLowerCase() && financeData) {
        store.commit(SET_SELECTEDPAYMENTOPTION, FINANCE.toLowerCase());
      } else if (adminDefaultValueCpo.toLowerCase() === CASH.toLowerCase()) {
        store.commit(SET_SELECTEDPAYMENTOPTION, CASH.toLowerCase());
      } else {
        // No action needed for other cases.
      }
    }
  }
}

export function getListPriceDetails(paymentSettings) {
  let listPrice = { key: '', value: '' };
  let isNewVehicle = Payments.isNewVehicle(paymentSettings);
  if (isNewVehicle) {
    listPrice.key = paymentSettings.listPriceLabel;
    listPrice.value =
      paymentSettings.listPriceValue && parseFloat(paymentSettings.listPriceValue) > 0
        ? '$' +
          Payments.convertNumberToPrice(
            Payments.conventStringToNumber(paymentSettings.listPriceValue)
          )
        : 0;
  } else {
    listPrice.key = paymentSettings.listPriceLabelUsed;
    listPrice.value =
      paymentSettings.listPriceValueUsed && parseFloat(paymentSettings.listPriceValueUsed) > 0
        ? '$' +
          Payments.convertNumberToPrice(
            Payments.conventStringToNumber(paymentSettings.listPriceValueUsed)
          )
        : 0;
  }
  return listPrice;
}

export function convertDateToString(date) {
  date = new Date(date);
  let year = date.getFullYear();

  let month = addZero(+date.getMonth() + 1);
  let dateText = addZero(date.getDate());
  let hours = addZero(date.getHours());
  let minutes = addZero(date.getMinutes());
  let seconds = addZero(date.getSeconds());
  return `${year}-${month}-${dateText}T${hours}:${minutes}:${seconds}.000Z`;
}
export function addZero(x) {
  if (x < 10) return '0' + x;
  return x;
}

export function getDownPaymentMaximumValue(paymentSettings, paymentsData, selectedPaymentOption) {
  if (!paymentsData) return 0;
  let percentageDetails = getPercentageDetails(
    paymentSettings.dealershipLenderMappings,
    paymentsData.LenderNumber,
    selectedPaymentOption
  );

  let percentage = percentageDetails / 100;
  let msrpValue = Payments.conventStringToNumber(paymentSettings.cashMSRP);
  let downpaymentmaxvalue = parseInt(msrpValue * percentage);
  return Math.ceil(downpaymentmaxvalue / 100) * 100;
}

export function getPercentageDetails(lenderDetails, lenderNumber, selectedPaymentOption) {
  let reductionNumber = '';
  for (let lender of lenderDetails) {
    if (+lender.lenderNumber === +lenderNumber) {
      reductionNumber = lender.maximumCapReduction;
      break;
    }
  }

  if (!reductionNumber) {
    let minimumPercentage = '';
    for (let lender of lenderDetails) {
      if (lender.dealScenarioType?.toLowerCase() === selectedPaymentOption) {
        if (!minimumPercentage) {
          minimumPercentage = lender.maximumCapReduction;
        } else if (lender.maximumCapReduction < minimumPercentage) {
          minimumPercentage = lender.maximumCapReduction;
        } else {
          // No action needed for other cases.
        }
      }
    }
    reductionNumber = minimumPercentage;
  }

  if (!reductionNumber) {
    if (selectedPaymentOption === LEASE.toLowerCase()) {
      reductionNumber = 20;
    } else {
      reductionNumber = 90;
    }
  }

  return reductionNumber;
}

export function getAccessoriesPrice(accessories) {
  let price = 0;
  for (let accessory of accessories) {
    price += accessory.Price;
  }
  return price;
}

export function getCustomFeesResultFromVin(feesResults) {
  let vin = window.vin ? window.vin.toLowerCase() : '';
  let selectedCustomFees = '';
  if (feesResults?.CustomFeeResults?.length) {
    selectedCustomFees = feesResults.CustomFeeResults.find((result) => {
      if (result?.Vin.toLowerCase() === vin) {
        return result;
      }
    });
    return selectedCustomFees;
  }
}

export function getFeeForType(data, offerType) {
  let feesValue = '';
  if (FINANCE.toLocaleLowerCase() === offerType.toLocaleLowerCase()) {
    feesValue = data.TotalFee_Finance;
  } else if (CASH.toLocaleLowerCase() === offerType.toLocaleLowerCase()) {
    feesValue = data.TotalFee_Cash;
  } else if (LEASE.toLocaleLowerCase() === offerType.toLocaleLowerCase()) {
    feesValue = data.TotalFee_Lease;
  } else {
    // No action needed for other cases.
  }
  return feesValue;
}

export function getFeeCollectionForType(data, offerType) {
  let feesCollection = '';
  feesCollection = data.FeesCollection.filter(
    (item) => item.OfferType.toLocaleLowerCase() === offerType.toLocaleLowerCase()
  );
  return feesCollection;
}

export function getFeesValue(feesResult, paymentsettings, offerType) {
  if (!feesResult) {
    feesResult = store.state.paymentsettings.feesResults;
  }
  let selectedFeesDetails = getCustomFeesResultFromVin(feesResult);
  let feesValue = '';
  let feesCollection = '';
  if (feesResult) {
    if (!selectedFeesDetails) {
      if (Payments.isNewVehicle(paymentsettings)) {
        feesCollection = getFeeCollectionForType(feesResult.FeesResultNew, offerType);
        feesValue = getFeeForType(feesResult.FeesResultNew, offerType);
      } else {
        feesCollection = getFeeCollectionForType(feesResult.FeesResultUsed, offerType);
        feesValue = getFeeForType(feesResult.FeesResultUsed, offerType);
      }
    } else {
      feesValue = getFeeForType(selectedFeesDetails, offerType);
      feesCollection = getFeeCollectionForType(selectedFeesDetails, offerType);
    }
  }

  if (feesCollection) {
    store.commit('setPaymentsFeesData', feesCollection);
  }
  return feesValue;
}
export function calculateIncentivesAmount(cashbackAmount, term) {
  console.log('cashback amount');
  console.log(cashbackAmount);
  const totalLeaseData = store.state.paymentsettings.totalLeaseData;
  const selectedPaymentOption = store.state.expressPaymentSettings.selectedPaymentOption;
  let cashValue = +cashbackAmount;

  if (selectedPaymentOption?.toLowerCase() === 'lease' && !cashValue) {
    if (totalLeaseData.length) {
      for (let lease of totalLeaseData) {
        if (+lease.term === term) {
          cashValue = lease.cash;
          break;
        }
      }
    }
  }

  console.log('cash Value' + cashValue);
  return cashValue;
}

export function getAISConditionalRebates(financeData, priceCondition) {
  const paymentsettings = store.state.paymentsettings;
  const aisRebates = store.state.paymentsettings.aisRebates;
  const selectedPaymentOption = store.state.expressPaymentSettings.selectedPaymentOption;
  let filteredData = [];
  if (
    selectedPaymentOption.toLocaleLowerCase() === LEASE.toLocaleLowerCase() &&
    aisRebates?.lease
  ) {
    const rebateDataLease = aisRebates.lease.map((item) => {
      return {
        DiscountBonus: item.totalConsumerCash,
        DiscountBonusDescription: item.programName,
        Disclaimer: item.disclaimer,
        Term: item.term,
      };
    });
    filteredData = rebateDataLease.filter((i) => i.Term === financeData.Term);
    filteredData = filteredData.length ? filteredData : rebateDataLease.filter((i) => !i.Term);
  } else if (
    selectedPaymentOption.toLocaleLowerCase() === FINANCE.toLocaleLowerCase() &&
    (aisRebates?.finance?.specialFinance || aisRebates?.finance?.standardFinance)
  ) {
    const aprRebates =
      aisRebates.finance.specialFinance?.filter(
        (item) => item.totalConsumerCash && item.term === financeData.Term
      ) || [];
    const financeRebates = aprRebates?.length
      ? aisRebates.finance.specialFinance
      : aisRebates.finance.standardFinance;

    const rebateDataFinance = financeRebates.map((item) => {
      return {
        DiscountBonus: item.totalConsumerCash,
        DiscountBonusDescription: item.programName,
        Disclaimer: item.disclaimer,
        Term: item.term,
      };
    });
    filteredData = rebateDataFinance.filter((i) => i.Term === financeData.Term);
    filteredData = filteredData.length ? filteredData : rebateDataFinance.filter((i) => !i.Term);
  } else if (
    aisRebates?.finance &&
    (aisRebates.finance.specialFinance.length ||
      aisRebates.finance.standardFinance.length ||
      (window.vehicleType.toLowerCase() === 'new' &&
        paymentsettings.showBuyForPrice &&
        aisRebates.cash.length))
  ) {
    const aprRebates =
      aisRebates.finance.specialFinance?.filter(
        (item) => item.totalConsumerCash && item.term === financeData.Term
      ) || [];

    let financeRebates = [];

    if (window.vehicleType.toLowerCase() === 'new' && paymentsettings.showBuyForPrice) {
      financeRebates = aisRebates.cash;
    } else {
      financeRebates = aprRebates?.length
        ? aisRebates.finance.specialFinance
        : aisRebates.finance.standardFinance;
    }

    const rebateDataCash = financeRebates.map((item) => {
      return {
        DiscountBonus: item.totalConsumerCash,
        DiscountBonusDescription: item.programName,
        Disclaimer: item.disclaimer,
        Term: item.term,
      };
    });
    filteredData = rebateDataCash.filter((i) => i.Term === financeData.Term);
    filteredData = filteredData.length ? filteredData : rebateDataCash.filter((i) => !i.Term);
  } else {
    // No action needed for other cases.
  }

  let totalIncentiveCash = 0;
  // Iterate through the collection
  filteredData.forEach((item) => {
    totalIncentiveCash += item.DiscountBonus;
  });
  let rebatesDiscounts = [];
  if (
    totalIncentiveCash === priceCondition ||
    totalIncentiveCash === paymentsettings.buyForRebate
  ) {
    rebatesDiscounts = filteredData;
  } else {
    rebatesDiscounts = [];
  }
  return rebatesDiscounts;
}

export function getSpecialTransactFeeData() {
  try {
    const paymentSettings = store.state.paymentsettings;
    let expressPaymentsFeesData = paymentSettings.expressPaymentsFeesData?.filter(
      (t) => t.ApplyToTransactPayments
    );
    let transactSpecialFee = 0;
    if (expressPaymentsFeesData?.length) {
      expressPaymentsFeesData.forEach((el) => {
        if (
          (paymentSettings?.settings?.vehicleType.toLowerCase() === 'new' &&
            paymentSettings?.settings?.showFeesNew &&
            el?.OfferType?.toLowerCase() === 'all') ||
          el?.OfferType?.toLowerCase() === CASH.toLowerCase()
        ) {
          transactSpecialFee = transactSpecialFee + el.Amount;
        }
        if (
          (paymentSettings?.settings?.vehicleType.toLowerCase() !== 'new' &&
            paymentSettings?.settings?.showFeesUsed &&
            el?.OfferType?.toLowerCase() === 'all') ||
          el?.OfferType?.toLowerCase() === CASH.toLowerCase()
        ) {
          transactSpecialFee = transactSpecialFee + el.Amount;
        }
      });
    }
    return transactSpecialFee;
  } catch (error) {
    console.log(error);
  }
}

export async function getPaymentSettingDetails(accountId, vin, styleid = '') {
  try {
    return await axios.get(
      `${window.ApiBaseUrl}/Inventory/getPaymentSettingDetails?accountId=${accountId}&vin=${vin}&styleid=${styleid}`
    );
  } catch (e) {
    console.log(e);
  }
}

export async function getCtaButtons() {
  const response = await axios.get(
    `${window.ApiBaseUrl}/inventoryctasettings/get?accountid=${window.accountId}&type=${window.homenetVehicleType}&pagetype=vdp`
  );
  return response.data;
}

export function setSummaryDataForAllPaymentTabs(activePaymentTabs) {
  if (!activePaymentTabs.length) return;
}

export function isAtcPayments(withTax = '') {
  const { expressPaymentSettings } = store.state;
  const { selectedCityIndex } = expressPaymentSettings;

  if (withTax !== '') {
    if (!withTax) {
      return false;
    }
  }
  if (selectedCityIndex === '') {
    return false;
  }

  return true;
}

export function buildTransactRequestData(selectedPaymentOption, withTax = '') {
  const { expressPaymentSettings } = store.state;
  const { selectedPaymentOption: defaultPaymentOption } = expressPaymentSettings;

  const paymentOption = selectedPaymentOption || defaultPaymentOption;
  const isAtc = isAtcPayments(withTax);

  const postData = isAtc
    ? preparePostDataForAtcPayments(paymentOption)
    : preparePostDataForPayments(paymentOption);

  return postData;
}

export async function callTransactPayments(selectedPaymentOption, withTax = '') {
  const { expressPaymentSettings } = store.state;
  const { selectedPaymentOption: defaultPaymentOption } = expressPaymentSettings;

  const paymentOption = selectedPaymentOption || defaultPaymentOption;

  const isAtc = isAtcPayments(withTax);

  const postData = buildTransactRequestData(paymentOption, withTax);
  if (isAtc) {
    return await ExpressPayments.getAtcPayments(postData);
  } else {
    return await ExpressPayments.getPayments(postData);
  }
}

export async function getIncentives(selectedPaymentOption, dealDetails) {
  let zipCode = ExpressPayments.getDealerZipCode();
  store.commit(EXPRESS_SET_DISCOUNT_INCENTIVES_LOADED, false);
  await ExpressPaymentsBaseService.getSpecialIncentives(selectedPaymentOption, zipCode)
    .then((response) => {
      store.commit(EXPRESS_SET_DISCOUNT_INCENTIVES_LOADED, true);
      let incentiveData = response.data;
      if (window.isFdDealer && isFordDealer(window.IncentiveSource)) {
        incentiveData = response?.data[0]?.Qualified;
        incentiveData = incentiveData.map((incentive) => {
          return {
            ...incentive,
            Cash: incentive.Amount,
            SpecialProgramName: incentive.NameDetailed,
          };
        });
      }

      if (selectedPaymentOption.toLowerCase() === LEASE.toLowerCase()) {
        store.commit(EXPRESS_SET_LEASE_INCENTIVES, incentiveData);
      } else if (selectedPaymentOption.toLowerCase() === FINANCE.toLowerCase()) {
        store.commit(EXPRESS_SET_FINANCE_INCENTIVES, incentiveData);
      } else if (selectedPaymentOption.toLowerCase() === CASH.toLowerCase()) {
        store.commit(EXPRESS_SET_CASH_INCENTIVES, incentiveData);
      } else {
        //No action needed for other cases
      }

      const toyotaSource = [
        TOYOTA_INCENTIVE_SOURCE.toLowerCase(),
        TOYOTA_INCENTIVE_DDOA_SOURCE.toLowerCase(),
      ];
      if (
        store.state.expressPaymentSettings?.creditScoreFormDetails?.autoApplyStandardIncentives &&
        toyotaSource.includes(window.IncentiveSource.toLowerCase())
      ) {
        const incentives = [];
        incentiveData.forEach((i) => {
          if (i.IsStandard) {
            incentives.push(i);
          }
        });
        store.commit(EXPRESS_SET_SUMMARY_DATA, {
          type: SUMMARY_INCENTIVES,
          selectedPaymentOption: selectedPaymentOption,
          value: incentives,
        });
        const selectedIncentivesAmount = incentives?.reduce((total, item) => total + item.Cash, 0);

        store.commit(EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT, {
          type: selectedPaymentOption,
          value: selectedIncentivesAmount,
        });
      }
      transactActiveSectionLoaded(selectedPaymentOption, TRANSACT_INCENTIVES_SECTION);
      return response.data;
    })
    .catch((error) => {
      console.log(error);
      transactActiveSectionLoaded(selectedPaymentOption, TRANSACT_INCENTIVES_SECTION);
    });
}

function checkForDealInIncentives(dealDetails, selectedPaymentOption, selectedIncentivesAmount) {
  try {
    let dealIncentives = dealDetails?.dealIncentives ? dealDetails.dealIncentives : [];
    let incentives = [];
    if (dealIncentives?.length) {
      for (let value of dealIncentives) {
        let cashAmount = 'cash' in value ? value.cash : value.Cash;
        incentives = [...incentives, { ...value }];
        selectedIncentivesAmount += +cashAmount;
      }
    }

    store.commit(EXPRESS_SET_SUMMARY_DATA, {
      type: SUMMARY_INCENTIVES,
      value: incentives,
    });

    store.commit(EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT, {
      type: selectedPaymentOption.toLowerCase(),
      value: selectedIncentivesAmount,
    });
    if (this.selectedPaymentOption.toLowerCase() === CASH.toLowerCase()) {
      const expressPaymentsStateData = store.state.expressPaymentSettings;
      setSummaryDataForCashIncentives(
        selectedIncentivesAmount,
        expressPaymentsStateData.summaryData.paymentsData,
        expressPaymentsStateData.mainTradeValue
      );
    }
  } catch (e) {
    console.log(e);
  }
}

export function preparePostDataForAtcPayments(selectedPaymentOption) {
  const expressPaymentsStateData = store.state.expressPaymentSettings;
  const paymentSettings = store.state.paymentsettings;
  selectedPaymentOption = selectedPaymentOption || expressPaymentsStateData.selectedPaymentOption;

  let expressPaymentConfiguration =
    expressPaymentsStateData.summaryData[selectedPaymentOption][SUMMARY_SELECTED_VALUES];
  if (selectedPaymentOption.toLowerCase() === CASH.toLowerCase()) {
    expressPaymentConfiguration =
      expressPaymentsStateData.summaryData['finance'][SUMMARY_SELECTED_VALUES];
  }

  const accessoriesPrice = getAccessoriesPrice(expressPaymentsStateData.selectedAccessories);
  let tradeValue = +expressPaymentConfiguration[PAYMENT_CONFIGURATION_TRADE_VALUE];

  const offerType =
    selectedPaymentOption.toLowerCase() === LEASE.toLowerCase() ? 'Closed End' : 'Loan';

  const paymentByTerm = paymentSettings.completePaymentsData.filter(
    (item) =>
      item.Term === +expressPaymentConfiguration[PAYMENT_CONFIGURATION_TERM] &&
      item.OfferType === offerType
  )[0];

  const totalCashBack =
    selectedPaymentOption.toLowerCase() === CASH.toLowerCase() &&
    paymentSettings.settings.showBuyForPrice
      ? paymentSettings.settings.buyForRebate
      : paymentByTerm?.IncentiveCash;

  const selectedIncentives =
    expressPaymentsStateData.summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_INCENTIVES] ||
    [];
  const selectedIncentiveTotal = selectedIncentives?.reduce((total, item) => total + item.Cash, 0);

  const incentivesAmount = selectedIncentiveTotal + (totalCashBack || 0);

  let postData = {
    AccountID: window.vdpAccountId ? window.vdpAccountId : window.accountId,
    PaymentFormatting: true,
    DownPayment: +expressPaymentConfiguration[PAYMENT_CONFIGURATION_DOWN_PAYMENT],
    Type: selectedPaymentOption,
    MileageAllowance: expressPaymentConfiguration[PAYMENT_CONFIGURATION_MILEAGE],
    VIN: window.paymentsvin,
    State: expressPaymentsStateData.regions[expressPaymentsStateData.selectedCityIndex].State,
    City: expressPaymentsStateData.regions[expressPaymentsStateData.selectedCityIndex].City,
    county: expressPaymentsStateData.regions[expressPaymentsStateData.selectedCityIndex].County,
    DealerCash:
      expressPaymentsStateData.summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]
        .DealerCash,
    TotalCashBack: totalCashBack || 0,
    Discount:
      expressPaymentsStateData.summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]
        .Discount,
    Term: +expressPaymentConfiguration[PAYMENT_CONFIGURATION_TERM],
    LenderNumber: paymentByTerm ? paymentByTerm.LenderNumber : null,
    ApplyIncentives: '1',
    DeliveryFee: store.state.expressPaymentSettings.deliveryFare?.fare || 0,
  };

  if (incentivesAmount) {
    postData = {
      ...postData,
      ...{
        IncludeTaxes: true,
        TotalCashBack: incentivesAmount,
      },
    };
  }

  if (accessoriesPrice) {
    postData['AccessoriesPrice'] = accessoriesPrice;
  }

  if (expressPaymentsStateData.tradeLeaseOptions.turnLease === 'Turn in my lease early') {
    postData['LeaseEarlyAmount'] =
      expressPaymentsStateData.tradeLeaseOptions.monthlyPayments *
      expressPaymentsStateData.tradeLeaseOptions.remainingPayments;
  }
  postData['TradeValue'] = 0;
  //end Discounts and incentives data
  if (expressPaymentsStateData.tradeLeaseOptions.turnLease !== 'Turn in my lease early') {
    if (expressPaymentsStateData.selectedTradeValue) {
      postData['TradeValue'] = +expressPaymentsStateData.mainTradeValue;
      postData['TradeEquity'] = +expressPaymentsStateData.selectedTradeValue;
    } else if (+tradeValue) {
      postData['TradeEquity'] = +tradeValue;
    } else {
      //No action needed for other cases
    }
  }

  if (+expressPaymentsStateData.mainTradeValue) {
    postData['TradeValue'] = +expressPaymentsStateData.mainTradeValue;
  }

  if (expressPaymentsStateData.selectedCreditScore) {
    postData.creditRating = +expressPaymentsStateData.selectedCreditScore;
  }

  if (selectedPaymentOption.toLowerCase() === CASH.toLowerCase()) {
    postData['vehicleLienStatus'] = 0;
    postData['isCash'] = true;
    postData['Type'] = 'finance';
    postData['Discount'] =
      expressPaymentsStateData.summaryData[FINANCE.toLowerCase()][SUMMARY_PAYMENTDATA].Discount;
    try {
      let isNewVehicle = Payments.isNewVehicle(paymentSettings);
      if (isNewVehicle && paymentSettings.showBuyForPrice) {
        postData['Discount'] = paymentSettings.buyForDiscount;
      }
    } catch (e) {
      console.log('unable to find buy for price discount');
    }
  }

  postData['LenderNumber'] = paymentByTerm ? paymentByTerm.LenderNumber : null;

  postData['ProgramDSType'] = paymentByTerm ? paymentByTerm.ProgramDSType : '';

  if (selectedPaymentOption.toLowerCase() === LEASE.toLowerCase()) {
    postData['Residual'] = paymentByTerm ? paymentByTerm.Residual : '';
  }

  if (
    expressPaymentsStateData.selectedCityIndex !== '' &&
    expressPaymentsStateData.regions.length
  ) {
    postData['OutsideCityLimits'] =
      expressPaymentsStateData.regions[
        expressPaymentsStateData.selectedCityIndex
      ].outsideCityLimits;
  }
  return postData;
}

export function preparePostDataForPayments(selectedPaymentOption) {
  const expressPaymentsStateData = store.state.expressPaymentSettings;
  const paymentSettings = store.state.paymentsettings;
  selectedPaymentOption = selectedPaymentOption || expressPaymentsStateData.selectedPaymentOption;
  const accessoriesPrice = getAccessoriesPrice(expressPaymentsStateData.selectedAccessories);

  let expressPaymentConfiguration =
    expressPaymentsStateData.summaryData[selectedPaymentOption][SUMMARY_SELECTED_VALUES];
  if (selectedPaymentOption.toLowerCase() === CASH.toLowerCase()) {
    expressPaymentConfiguration =
      expressPaymentsStateData.summaryData['finance'][SUMMARY_SELECTED_VALUES];
  }

  let tradeValue = +expressPaymentConfiguration[PAYMENT_CONFIGURATION_TRADE_VALUE];

  const offerType =
    selectedPaymentOption.toLowerCase() === LEASE.toLowerCase() ? 'Closed End' : 'Loan';

  let downPayment = +expressPaymentConfiguration[PAYMENT_CONFIGURATION_DOWN_PAYMENT];

  let postData = {
    Customize: 1,
    Downpayment: downPayment,
    Term: +expressPaymentConfiguration[PAYMENT_CONFIGURATION_TERM],
    Type: selectedPaymentOption.toLowerCase(),
    PaymentFormatting: true,
    DealerCash:
      expressPaymentsStateData.summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]
        .DealerCash,
    ApplyIncentives: '1',
    DeliveryFee: store.state.expressPaymentSettings.deliveryFare?.fare || 0,
  };

  if (expressPaymentsStateData.selectedCreditScore) {
    postData.creditRating = +expressPaymentsStateData.selectedCreditScore;
  }

  if (+expressPaymentConfiguration[PAYMENT_CONFIGURATION_MILEAGE]) {
    postData['MileageAllowance'] = +expressPaymentConfiguration[PAYMENT_CONFIGURATION_MILEAGE];
  }

  if (expressPaymentsStateData.tradeLeaseOptions.turnLease === 'Turn in my lease early') {
    postData['LeaseEarlyAmount'] =
      expressPaymentsStateData.tradeLeaseOptions.monthlyPayments *
      expressPaymentsStateData.tradeLeaseOptions.remainingPayments;
  }

  const paymentByTerm = paymentSettings.completePaymentsData.filter(
    (item) =>
      item.Term === +expressPaymentConfiguration[PAYMENT_CONFIGURATION_TERM] &&
      item.OfferType === offerType
  )[0];

  const selectedIncentives =
    expressPaymentsStateData.summaryData[selectedPaymentOption][SUMMARY_INCENTIVES] || [];
  const selectedIncentiveTotal = selectedIncentives?.reduce((total, item) => total + item.Cash, 0);

  const totalCashBack =
    selectedPaymentOption.toLowerCase() === CASH.toLowerCase() &&
    paymentSettings.settings.showBuyForPrice
      ? paymentSettings.settings.buyForRebate
      : paymentByTerm?.IncentiveCash;
  const incentivesValue = selectedIncentiveTotal + (totalCashBack || 0);

  postData['TotalCashBack'] = incentivesValue || 0;

  //end Discounts and incentives data
  postData['TradeValue'] = 0;

  if (selectedPaymentOption.toLowerCase() === CASH.toLowerCase()) {
    postData['isCash'] = true;
    postData['Type'] = 'finance';
  }

  if (accessoriesPrice) {
    postData['AccessoriesPrice'] = +accessoriesPrice.toFixed(2);
  }

  if (expressPaymentsStateData.tradeLeaseOptions.turnLease !== 'Turn in my lease early') {
    if (expressPaymentsStateData.selectedTradeValue) {
      postData['TradeValue'] = +expressPaymentsStateData.mainTradeValue;
      postData['TradeEquity'] = +expressPaymentsStateData.selectedTradeValue;
    } else if (+tradeValue) {
      postData['TradeEquity'] = +tradeValue;
    } else {
      //No action needed for other cases
    }
  }

  let discount =
    expressPaymentsStateData.summaryData[selectedPaymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]
      .Discount;

  if (discount) {
    postData['Discount'] = discount;
  }

  postData['LenderNumber'] = paymentByTerm ? paymentByTerm.LenderNumber : null;
  postData['ProgramDSType'] = paymentByTerm ? paymentByTerm.ProgramDSType : '';
  postData['Source'] = 'transact';

  return postData;
}

export function getDealerZipCode() {
  let zipCode = window.zip;
  if (zipCode) {
    return zipCode.split('-')[0];
  }
  return '';
}

export async function getAllRegions(zipCode) {
  let response = await ExpressPayments.getRegions(zipCode);
  store.commit(EXPRESS_SET_REGIONS, response);
  return response;
}

export async function adjustSummaryDataForTab(paymentOption, settings) {
  const expressPaymentsStateData = store.state.expressPaymentSettings;

  // Determine if tax is needed for this payment
  const withTax = doWeNeedTaxForThePayment(paymentOption);

  try {
    // If tax is needed, ensure we have selected a valid city or update it using the dealer's zip code
    if (withTax) {
      let selectedCityIndex = expressPaymentsStateData.selectedCityIndex;

      if (selectedCityIndex === '') {
        const zipCode = getInitialZipCode(paymentOption);

        if (zipCode) {
          const regions = await getAllRegions(zipCode);

          // Update city index if regions are returned
          if (regions.length) {
            store.commit(EXPRESS_SET_REGIONS_CHANGE, 0);
          }
        }
      }
    }
    const { dealDetails } = expressPaymentsStateData;
    await getIncentives(paymentOption.toLowerCase(), dealDetails);
    // Call the payment API and frame the response data
    const response = await callTransactPayments(paymentOption, withTax);
    frameSummaryPaymentsData(response, paymentOption);
  } catch (error) {
    console.error('Error adjusting summary data for tab:', error);
    // Optionally, handle the error in a user-friendly way, e.g., show a notification or default values.
  }
}

export function frameSummaryPaymentsData(response, selectedPaymentOption) {
  const isPaymentCollectionAvailable = response?.PaymentCollection?.length > 0;
  const isAtc = isAtcPayments();
  const expressPaymentsStateData = store.state.expressPaymentSettings;
  const defaultPaymentOption = expressPaymentsStateData.selectedPaymentOption;

  const paymentOption = selectedPaymentOption || defaultPaymentOption;

  store.commit('setExpressPaymentsFeesData', '');
  if (response?.FeesAndTaxesCollection) {
    store.commit('setExpressPaymentsFeesData', response.FeesAndTaxesCollection);
  }

  if (isPaymentCollectionAvailable) {
    let paymentsData = Payments.GetPaymentByTermFromCollection(
      response.PaymentCollection,
      +expressPaymentsStateData.expressPaymentConfiguration[PAYMENT_CONFIGURATION_TERM]
    );

    let cashSummaryData = '';
    if (paymentOption.toLowerCase() === CASH.toLowerCase()) {
      cashSummaryData = {
        ...expressPaymentsStateData.summaryData['cash'].paymentData,
        paymentsData,
      };
    }

    store.commit(EXPRESS_SET_SUMMARY_DATA, {
      type: SUMMARY_PAYMENTDATA,
      selectedPaymentOption: paymentOption.toLowerCase(),
      value: cashSummaryData || paymentsData,
    });

    try {
      if (paymentOption.toLowerCase() === 'cash') {
        calculateSummaryDataForCash();
      }
    } catch (e) {
      console.log(e);
    }

    store.commit(EXPRESS_SET_SELECTED_INCENTIVES_AMOUNT, {
      type: paymentOption.toLowerCase(),
      value: paymentsData.IncentiveCash,
    });
  } else {
    if (paymentOption.toLowerCase() !== CASH.toLowerCase()) {
      store.commit(EXPRESS_SET_PAYMENT_CONFIGURATION, {
        ...expressPaymentsStateData.expressPaymentConfiguration,
        term: expressPaymentsStateData.summaryData[paymentOption.toLowerCase()][SUMMARY_PAYMENTDATA]
          .Term,
      });
    } else {
      if (isAtc) {
        calculateTaxWithoutPayments(
          response,
          expressPaymentsStateData.summaryData['cash'].paymentData
        );
      }
      calculateSummaryDataForCash();
    }

    let message =
      'We are having difficulty while calculating Payments. Please try with other Options';

    if (response?.Message) {
      message = response?.Message;
    }
    store.commit(EXPRESS_SET_PAYMENTS_NOT_FOUND_ERROR, {
      type: paymentOption.toLowerCase(),
      message: message,
    });
  }
}

export function doWeNeedTaxForThePayment(paymentOption) {
  const selectedCityIndex = getTaxSelectedRegion(paymentOption);

  if (selectedCityIndex === '') {
    return false;
  }

  return true;
}

export function isZipCodeManuallyChanged() {
  const isZipCodeManual = store.state.expressPaymentSettings.isZipCodeChangedManual;
  return isZipCodeManual;
}

export function isLoggedInUser() {
  return window.isauthenticated.toLowerCase() === 'true';
}

export function getInitialZipCode(selectedPaymentOption) {
  const { expressPaymentSettings } = store.state;
  const { selectedPaymentOption: defaultPaymentOption } = expressPaymentSettings;

  const paymentOption = selectedPaymentOption || defaultPaymentOption;
  const selectedSettings = expressPaymentSettings.paymentSettings[paymentOption];
  const sessionZipCode = sessionStorage.getItem(window.tid + '-tax-zip-code') || '';
  const dealerZipCode = getDealerZipCode();
  const zipManuallyChanged = isZipCodeManuallyChanged();

  const useDealerZipCodeForTaxes = selectedSettings.useDealerZipCodeForTaxes;

  if (sessionZipCode) {
    return sessionZipCode;
  }

  if (zipManuallyChanged) {
    if (expressPaymentSettings.taxZipCode) {
      return expressPaymentSettings.taxZipCode;
    }
  }

  if (useDealerZipCodeForTaxes) {
    return dealerZipCode;
  }
  return '';
}

export function getTaxSelectedRegion(selectedPaymentOption) {
  const { expressPaymentSettings } = store.state;
  const { selectedPaymentOption: defaultPaymentOption } = expressPaymentSettings;
  const selectedRegionInStore = expressPaymentSettings.selectedCityIndex;
  const sessionRegion = sessionStorage.getItem(window.tid + '-tax-zip-code-key');

  const zipManuallyChanged = isZipCodeManuallyChanged();
  const paymentOption = selectedPaymentOption || defaultPaymentOption;
  const zipCode = getInitialZipCode(paymentOption);

  const useDealerZipCodeForTaxes =
    expressPaymentSettings.paymentSettings[paymentOption].useDealerZipCodeForTaxes;

  if (sessionRegion !== null && sessionRegion !== undefined) {
    if (zipCode) {
      return sessionRegion + '';
    }
  }

  if (zipManuallyChanged) {
    if (sessionRegion !== null && sessionRegion !== undefined) {
      return sessionRegion + '';
    } else if (selectedRegionInStore) {
      return selectedRegionInStore + '';
    } else {
      return '';
    }
  } else if (useDealerZipCodeForTaxes) {
    return '0';
  }

  return '';
}
